import { INITIAL_SAVE_REQUEST_META } from '../utils';
import { AiContentWidgetData } from './types';

const defaultAiContentWidgetData: NonNullable<AiContentWidgetData['initialData']> = {
  showAi: true,
};

export const defaultAiContentWidgetState: AiContentWidgetData = {
  initialData: defaultAiContentWidgetData,
  currentData: defaultAiContentWidgetData,
  isDirty: false,
  saveRequest: INITIAL_SAVE_REQUEST_META,
};
